/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Link } from "react-router-dom";
import { MPagination } from "../../../../../helper/pagination";
import {
  Action,
  ActionType,
  Customer,
  CustomerUI,
} from "../../entity/customer.model";

export const customerTableColumns: ColumnsType<CustomerUI> = [
  {
    title: "Д/д",
    dataIndex: "index",
    key: "index",
  },
  {
    title: "Байгууллагын ажлын нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Байгууллагын код",
    dataIndex: "companyCode",
    key: "companyCode",
  },
  {
    title: "Толгой байгууллагын регистер",
    dataIndex: "headCompanyRegister",
    key: "headCompanyRegister",
  },
  {
    title: "Толгой байгууллагын нэр",
    dataIndex: "headCompanyName",
    key: "headCompanyName",
  },
  {
    title: "Хаяг",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Үйлдлүүд",
    align: "center",
    key: "actions",
    dataIndex: "actions",
    render: (actions: Action[], record: CustomerUI) => (
      <div className="list-icons">
        <div className="dropdown">
          <a href="#" className="list-icons-item" data-toggle="dropdown">
            <i className="icon-menu9"></i>
          </a>

          <div className="dropdown-menu dropdown-menu-right">
            {actions.map((action: Action) => {
              if (action.type === ActionType.edit) {
                return (
                  <Link
                    key={`action-${record.uuid}`}
                    to={`/customers/${record.uuid}`}
                    className="dropdown-item"
                  >
                    <i className={action.icon}></i>
                    {action.text}
                  </Link>
                );
              } else {
                return <></>;
              }
            })}
          </div>
        </div>
      </div>
    ),
  },
];

export interface CustomerTableProps {
  pagination: MPagination<Customer>;
  onChange: (page: number, pageSize: number) => void;
}

function CustomerTable(props: CustomerTableProps) {
  const customerUIs: CustomerUI[] = props.pagination.results.map(
    (customer, index) => {
      const actions: Action[] = [
        { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      ];
      return {
        ...customer,
        actions: actions,
        index: index + 1,
        key: index,
      };
    }
  );

  return (
    <Table
      className="table table-responsive"
      columns={customerTableColumns}
      dataSource={customerUIs}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.count,
        onChange: props.onChange,
      }}
    />
  );
}

export default CustomerTable;
